/* @flow */
import { ActionTypes as WidgetActionTypes } from '../constants/WidgetConstants';
import { dispatcher } from 'lib/Dispatcher';
import Widgets from 'collections/Widgets';

const WidgetActions = {
  loadWidgets(): Promise<void> {
    return Widgets.fetch().then(widgets => {
      dispatcher.dispatch({
        type: WidgetActionTypes.WIDGETS_LOADED,
        widgets,
      });
    });
  },
};

export default WidgetActions;



// WEBPACK FOOTER //
// ./src/settings/actions/WidgetActions.js